/**
 * Configuration for a single field in a card
 */
export interface CardFieldConfig<T = unknown> {
  /**
   * The property key from the data object to display
   */
  key: keyof T | string;

  /**
   * The type of field to render
   */
  type: 'text' | 'date' | 'badge' | 'avatar' | 'button' | 'link';

  /**
   * Where in the card to render this field
   */
  position: 'header' | 'body' | 'footer';

  /**
   * Optional label to display before the value
   */
  label?: string;

  /**
   * Optional icon class (e.g., 'fas fa-user')
   */
  icon?: string;

  /**
   * Position of the icon relative to the label
   * Default: 'before'
   */
  iconPosition?: 'before' | 'after';

  /**
   * Whether this field should be searchable
   */
  searchable?: boolean;

  /**
   * Weight for search ranking (higher = more important)
   * Default: 1
   */
  searchWeight?: number;

  /**
   * Optional formatter function to transform the value for display
   */
  formatter?: (value: unknown, item: T) => string;

  /**
   * Optional function to determine if this field should be visible
   */
  visible?: (item: T) => boolean;

  /**
   * CSS class to apply to the field container
   * Can be a string or a function that returns a string based on the item
   */
  cssClass?: string | ((item: T) => string);

  /**
   * Click handler for button type fields
   */
  onClick?: (item: T, event: Event) => void;
}
